import { Box, Typography, useTheme } from '@mui/material';
import { Star } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { hotelViewStyles } from './styles';

interface HotelRatingDisplayProps {
  rating: number;
  impressions: number;
}

export const HotelRatingDisplay = ({ rating, impressions }: HotelRatingDisplayProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const renderStars = () => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(
        <Star
          key={i}
          sx={{
            color: i < rating ? theme.palette.secondary.main : theme.palette.grey[300],
          }}
        />,
      );
    }
    return stars;
  };

  return (
    <Box sx={hotelViewStyles.ratingContainer}>
      <Box>{renderStars()}</Box>
      <Box sx={hotelViewStyles.ratingInfo}>
        <Typography variant="body1" color="text.primary">
          {rating}
        </Typography>
        <Typography variant="caption" color="text.disabled">
          {t('hotelContent.nimbuxHotels.card.opinions', { count: impressions })}
        </Typography>
      </Box>
    </Box>
  );
};
